import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const SingleItemTable = ({ data, title }) => {
    const color = useSelector(getAppColor);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h6" style={{ color: color }}>
                    {getLocalizedString("byDate")}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6">{title}</Typography>
            </Grid>
            <Grid item xs={12} style={{ padding: "0px 6px 6px 0px" }} />
            {Object.keys(data).map((key, index) => (
                <Grid key={index} item container xs={12}>
                    <Typography style={{ marginRight: 5, fontWeight: "bold" }}>{key + ":"}</Typography>
                    <Typography>{data[key]}</Typography>
                </Grid>
            ))}
        </Grid>
    );
};

export default SingleItemTable;
